export const OPEN_DIALOG = 'OPEN_DIALOG'
export const CLOSE_DIALOG = 'CLOSE_DIALOG'
export const DIALOG_SET_LOADING = 'DIALOG_SET_LOADING'
